import React, { useEffect, useState } from 'react';
import { GetPropertyReviews } from '../../utility/apiServices/userServices';
import { useLocation, useNavigate } from 'react-router-dom';
import { Image } from 'react-bootstrap';
import { IMAGES } from '../../assets/images/images';
import { Icon } from "@iconify/react";

export const formatDate = (dateString) => {
    const date = new Date(dateString);
    const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const day = date.getUTCDate();
    const month = monthNames[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    return `${day} ${month} ${year}`;
};

const ReviewListing = () => {
    const location = useLocation();
    const { property } = location.state || {};
    const navigate = useNavigate();

    const [reviews, setreviews] = useState([]);
    const [isExpandedReview, setIsExpandedReview] = useState([]);

    const getData = async (property) => {
        let response = await GetPropertyReviews(property.id, 1);
        if (response?.status) {
            setreviews(response?.reviews);
            setIsExpandedReview(response?.reviews.map(() => false));
        }
    };

    useEffect(() => {
        if (property) {
            getData(property);
        }
    }, [property]);

    const handleToggleDescription = (index) => {
        setIsExpandedReview((prevState) => {
            const newState = [...prevState];
            newState[index] = !newState[index];
            return newState;
        });
    };

    return (
        <div style={styles.container}>


            {reviews?.length ? (
                <div style={styles.contentContainer} className='review_listflex'>
                  <div className='d-flex gap-2 align-items-center justify-content-between'>
                        <h2 style={styles.title}>Reviews ({reviews.length})</h2>
                        <button style={styles.goBackButton} onClick={() => window.history.back()}>
                           {`Go Back`}
                        </button>
                    </div>

                    <ul style={styles.reviewList}>
                        {reviews.map((review, index) => {
                            const description = review?.description || '';
                            const truncatedDescription = description.length > 150 && !isExpandedReview[index]
                                ? description.substring(0, 150) + '...'
                                : description;

                            return (
                                <li key={review.id} style={styles.reviewItem}>
                                    <Image
                                        src={review?.User?.profile_url || IMAGES.PlaceHolderUserImage}
                                        alt="User Profile"
                                        style={styles.userImage}
                                    />
                                    <div style={styles.reviewContent}>
                                        <div style={styles.reviewHeader} className='review_headerFlex'>
                                            <h3 className='mb-0'>{review?.User?.name}</h3>
                                            <div  className='d-flex align-items-center'>
                                                <div style={styles.starRating} className='mx-2 align-items-center'>
                                                    {[...Array(review?.rating)].map((_, index) => (
                                                        <Icon key={index} icon="ph:star-fill" color="#E1C03F" />
                                                    ))}
                                                    {[...Array(5 - review?.rating)].map((_, index) => (
                                                        <Icon key={index} icon="ph:star" color="#E1C03F" />
                                                    ))}
                                                    <span style={styles.starCount}>{review?.rating}</span>
                                                </div>
                                                <span style={styles.date} className='ms-auto'>{formatDate(review?.createdAt)}</span>
                                            </div>
                                        </div>
                                        <p>
                                            {truncatedDescription}
                                            {description.length > 150 && (
                                                <span
                                                    onClick={() => handleToggleDescription(index)}
                                                    style={styles.readMore}
                                                >
                                                    {isExpandedReview[index] ? ' Read less' : ' Read more'}
                                                </span>
                                            )}
                                        </p>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            ) : (
                <p>No reviews available.</p>
            )}
        </div>
    );
};

const styles = {
    container: {
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: '#f9f9f9',
    },
    goBackButton: {
        marginBottom: '20px',
        padding: '10px 20px',
        cursor: 'pointer',
        backgroundColor: '#1d91bf',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
    },
    contentContainer: {
        width: '90%',
        maxWidth: '1200px',
        backgroundColor: 'white',
        padding: '20px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
    },
    title: {
        fontSize: '24px',
        fontWeight: 'bold',
        marginBottom: '20px',
    },
    reviewList: {
        listStyleType: 'none',
        padding: '0',
    },
    reviewItem: {
        display: 'flex',
        padding: '15px',
        borderBottom: '1px solid #eee',
    },
    userImage: {
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        marginRight: '15px',
    },
    reviewContent: {
        flex: 1,
    },
    reviewHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '10px',
    },
    starRating: {
        display: 'flex',
    },
    starCount: {
        marginLeft: '5px',
        fontSize: '16px',
    },
    date: {
        fontSize: '14px',
        color: '#888',
    },
    readMore: {
        color: 'blue',
        cursor: 'pointer',
        fontSize: '14px',
    },
};

export default ReviewListing;
